import LTList from "../../LTGame/LTUtils/LTList";
import { LTUtils } from "../../LTGame/LTUtils/LTUtils";
import MathEx from "../../LTGame/LTUtils/MathEx";
import QuaternionEx from "../../LTGame/LTUtils/QuaternionEx";
import { TransformEx } from "../../LTGame/LTUtils/TransformEx";
import Vector3Ex from "../../LTGame/LTUtils/Vector3Ex";
import LTRes from "../../LTGame/Res/LTRes";
import GlobalUnit from "../common/GlobalUnit";
import ResDefine from "../common/ResDefine";
import { PetConfig } from "../config/PetConfig";
export default class ViewPet {
    constructor() {
        this.cacheTime = 0;
        this.updateRandomTime = MathEx.Random(4, 6);
    }
    SetPetId(id) {
        this.config = PetConfig.data[id];
    }
    PreLoad(urls) {
        if (!this.config)
            return;
        urls.push(ResDefine.FixPath(this.config.model_path));
        urls.push(ResDefine.FixPath(this.config.ammo_model));
    }
    CreatePet(owner) {
        if (!this.config)
            return;
        this.rootObj = new Laya.Sprite3D("view_pet");
        let model = LTRes.Get(ResDefine.FixPath(this.config.model_path));
        this.rootObj.addChild(model);
        this.sendPoint = LTUtils.FindChild(model, this.config.send_point);
        TransformEx.ResetLocalTrans(model.transform);
        model.transform.localPositionY = 3;
        GlobalUnit.game.level.AddItemToLevel(this.rootObj);
        this.owner = owner;
        let pos = owner.GetRootPos();
        this.rootObj.transform.position = pos;
        this.cacheOffset = Vector3Ex.Subtract(pos, this.rootObj.transform.position);
        this.offset = new Laya.Vector3();
        this.offset.z = 0;
        this.offset.setValue(0, pos.y, 0);
        this.nextAttTime = this.config.att_gap;
        this.ammoObj = LTRes.Get(ResDefine.FixPath(this.config.ammo_model));
        this.ammoList = new LTList();
        this.RandomOffet();
    }
    OnMove(dt) {
        let target = this.owner.GetRootPos().clone();
        this.cacheOffset = Vector3Ex.Lerp(this.cacheOffset, this.offset, 0.1);
        let last = this.rootObj.transform.position.x;
        // target.x = MathEx.Lerp(last, target.x, 0.1);
        this.rootObj.transform.position = Vector3Ex.Add(target, this.cacheOffset);
        if (!this.isPlayRotate) {
            if (!this.blnAtt) {
                this.rootObj.transform.localRotationEulerY = (this.rootObj.transform.position.x - last) * 80;
            }
            else {
                let vec3 = Vector3Ex.Subtract(this.targetEnemy.rootObj.transform.position, this.rootObj.transform.position);
                vec3 = Vector3Ex.Normalize(vec3);
                this.rootObj.transform.localRotationEulerY = Vector3Ex.SignAngleAsix(Vector3Ex.s_forward, vec3, Vector3Ex.s_up);
                this.OnSend(dt);
            }
        }
    }
    OnSend(dt) {
        if (this.config.ammo_type == 0) {
            if (!this.runAtt) {
                GlobalUnit.game.level.AddItemToLevel(this.ammoObj);
            }
            this.ammoObj.transform.localRotationEulerY = this.rootObj.transform.localRotationEulerY;
            let enemy = this.targetEnemy.rootObj.transform.position.clone();
            enemy.y += 1;
            this.ammoObj.transform.position = this.sendPoint.transform.position;
            let vec3 = Vector3Ex.Subtract(enemy, this.sendPoint.transform.position);
            let forward = QuaternionEx.Multiply(this.rootObj.transform.rotation, Vector3Ex.s_forward);
            this.ammoObj.transform.localRotationEulerX = Math.abs(Vector3Ex.SignedAngle(forward, vec3, Vector3Ex.right));
            this.ammoObj.transform.localScaleZ = Vector3Ex.Distance2D(this.ammoObj.transform.position, enemy);
            if (!this.lastTime || this.lastTime <= 0) {
                this.targetEnemy.UpdateHp(-this.config.damage);
                this.lastTime = this.config.damage_gap;
            }
            this.lastTime -= dt;
        }
        else {
            if (!this.lastTime || this.lastTime <= 0) {
                this.lastTime = this.config.damage_gap;
                this.AddAmmo();
            }
            this.lastTime -= dt;
        }
    }
    AddAmmo() {
        this.ammoList.Add(new ItemAmmo(this, this.targetEnemy));
    }
    RemoveAmmo(target) {
        this.ammoList.Remove(target);
    }
    UpdateAmmo(dt) {
        for (let i = 0; i < this.ammoList.Count; ++i) {
            this.ammoList.Get(i).Update(dt);
        }
    }
    OffSend() {
        if (this.config.ammo_type == 0) {
            if (!this.runAtt) {
                this.ammoObj.removeSelf();
            }
        }
    }
    RandomOffet() {
        this.offset.z = MathEx.Random(1, -2);
        this.offset.x = MathEx.Random(-3, 3);
        let rot = -720;
        if (this.offset.x > this.cacheOffset.x) {
            rot = 720;
        }
        this.RunRotate(rot, 800);
    }
    RunRotate(rot, duration) {
        if (this.isPlayRotate)
            return;
        this.rootObj.transform.localRotationEulerY = this.rootObj.transform.localRotationEulerY % 360;
        this.isPlayRotate = true;
        Laya.Tween.to(this.rootObj.transform, { localRotationEulerY: rot }, duration, Laya.Ease.circOut, Laya.Handler.create(this, () => {
            this.isPlayRotate = false;
        }));
    }
    Update(dt) {
        if (!this.rootObj)
            return;
        this.OnMove(dt);
        this.UpdateAmmo(dt);
        if (this.isPlayRotate)
            return;
        if (!this.blnAtt) {
            this.cacheTime += dt;
            if (this.cacheTime >= this.updateRandomTime) {
                this.updateRandomTime = MathEx.Random(4, 6);
                this.cacheTime = 0;
                this.RandomOffet();
            }
            this.nextAttTime -= dt;
            if (this.nextAttTime <= 0) {
                this.CheckEnemy();
            }
        }
        else {
            if (!this.targetEnemy.isEnabled || this.owner.GetRootPos().z >= this.targetEnemy.rootObj.transform.position.z) {
                this.OffSend();
                this.blnAtt = false;
                this.RandomOffet();
                this.nextAttTime = this.config.att_gap;
            }
        }
    }
    CheckEnemy() {
        let target = GlobalUnit.game.level.GetEnemy(this.owner.GetRootPos(), this.config.att_dist);
        if (target) {
            this.targetEnemy = target;
            if (!this.blnAtt) {
                let vec3 = Vector3Ex.Subtract(target.rootObj.transform.position, this.rootObj.transform.position);
                vec3 = Vector3Ex.Normalize(vec3);
                this.offset = Vector3Ex.Scale(vec3, 3);
                this.RunRotate(720, 300);
                this.blnAtt = true;
            }
            return true;
        }
        return false;
    }
    ChangeSkin(id) {
        return __awaiter(this, void 0, void 0, function* () {
            this.Destroy();
            if (id) {
                GlobalUnit.dataManager.tryPetId = id;
                let urls = [];
                this.SetPetId(GlobalUnit.dataManager.tryPetId);
                this.PreLoad(urls);
                yield LTRes.LoadAsync(urls);
                GlobalUnit.game.player.InitPet();
            }
        });
    }
    Destroy() {
        var _a, _b, _c;
        (_a = this.rootObj) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = this.ammoObj) === null || _b === void 0 ? void 0 : _b.destroy();
        this.rootObj = this.ammoObj = null;
        this.blnAtt = false;
        this.targetEnemy = null;
        (_c = this.ammoList) === null || _c === void 0 ? void 0 : _c.Clear();
    }
}
export class ItemAmmo {
    constructor(owner, enemy) {
        this.owner = owner;
        this.enemy = enemy;
        this.rootObj = LTRes.Get(ResDefine.FixPath(this.owner.config.ammo_model));
        GlobalUnit.game.level.AddItemToLevel(this.rootObj);
        this.rootObj.transform.position = this.owner.sendPoint.transform.position;
    }
    OnMove(dt) {
        let target = this.enemy.rootObj.transform.position.clone();
        target.y += 1;
        let old = this.rootObj.transform.position;
        let vec3 = Vector3Ex.Subtract(this.rootObj.transform.position, target);
        if (Vector3Ex.Distance(Vector3Ex.s_zero, vec3) <= 0.4) {
            this.enemy.UpdateHp(-this.owner.config.damage);
            this.Destroy();
            return;
        }
        // let temp = this.rootObj.transform.position;
        this.rootObj.transform.localRotationEulerY = Vector3Ex.SignAngleAsix(Vector3Ex.s_forward, Vector3Ex.Normalize(vec3), Vector3Ex.s_up);
        this.rootObj.transform.position = Vector3Ex.Add(old, Vector3Ex.Scale(Vector3Ex.Normalize(vec3), -30 * dt));
    }
    Destroy() {
        this.rootObj.destroy();
        this.owner.RemoveAmmo(this);
    }
    Update(dt) {
        if (this.enemy.rootObj.destroyed) {
            this.Destroy();
            return;
        }
        if (this.rootObj.destroyed)
            return;
        this.OnMove(dt);
    }
}
